import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { API_ENDPOINT } from '~/constants';

import type { TypeGetTemplatesDownloadUrlResponse } from '~/types/delivery-agency.types';

type FetchTemplatesDownloadUrlParams = {
  type: string;
};

/**
 * [배송 주문 관리] 주문 엑셀 양식 다운로드 URL 조회 API
 */
const fetchTemplatesDownloadUrl = async (
  params: FetchTemplatesDownloadUrlParams
): Promise<TypeGetTemplatesDownloadUrlResponse['data']> => {
  const { data } = await axiosInstance.get<TypeGetTemplatesDownloadUrlResponse>(
    API_ENDPOINT.DELIVERY_AGENCY.GET_TEMPLATES_DOWNLOAD_URL,
    { params }
  );
  return data.data;
};

/**
 * [배송 주문 관리] 주문 엑셀 양식 다운로드 URL 조회 Mutation Hook
 */
export const useGetTemplatesDownloadUrlMutation = () => {
  return useMutation({
    mutationFn: fetchTemplatesDownloadUrl,
  });
};
